/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ask_Upload_New_Cv_After_FeedbackInputs */

const en_ask_upload_new_cv_after_feedback = /** @type {(inputs: Ask_Upload_New_Cv_After_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to adjust your resume based on the feedback and upload a new file?`)
};

const de_ask_upload_new_cv_after_feedback = /** @type {(inputs: Ask_Upload_New_Cv_After_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du deinen Lebenslauf auf Grundlage des Feedbacks anpassen und eine neue Datei hochladen?`)
};

/**
* | output |
* | --- |
* | "Would you like to adjust your resume based on the feedback and upload a new file?" |
*
* @param {Ask_Upload_New_Cv_After_FeedbackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ask_upload_new_cv_after_feedback = /** @type {((inputs?: Ask_Upload_New_Cv_After_FeedbackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ask_Upload_New_Cv_After_FeedbackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ask_upload_new_cv_after_feedback(inputs)
	return en_ask_upload_new_cv_after_feedback(inputs)
});